<template>
  <div>
    <b-navbar v-if="this.$store.state.device.isMobile" id="navbarTop" toggleable="lg" type="dark">
      <b-row align-v="center">
        <b-col cols="9">
          <b-nav-text style="padding-left: 35%;color:#2B2D42;letter-spacing: 0.8px;font-size: 20px"><b>{{this.routeName}}</b></b-nav-text>
        </b-col>
        <b-col cols="3">
          <div class="circletag">
            <a v-on:click="profile">
              <img    style="width: 25px; height: 28px"
                      src="img/avatar.svg"/>
            </a>
          </div>
        </b-col>
      </b-row>
    </b-navbar>
    <b-navbar v-if="this.$store.state.device.isDesktop" id="navbarTop_desktop" :style="'background-image: linear-gradient('+this.$store.state.device.color+', #2B2D42 150%);'">
      <a v-on:click="redirectToHome"><img src="../../public/img/512.png" class="logo_desktop"><label class="label_logo">Pevidém SC</label></a>
      <a v-on:click="toggleProfile" v-click-outside="hideProfile"><img src="img/avatar_white.svg" class="avatar_desktop"/></a>
    </b-navbar>
    <div v-if="toggle_profile" class="profile">
        <div class="circle">
          <img :src="this.$store.state.device.image">
        </div>
        <div style="margin-top: 10px;margin-bottom: 10px"><b style="color: #2B2B2B; font-size: 18px;">{{this.$store.state.device.organization}}</b></div>
        <div>
          <label style="color: #2B2B2B;"><b>{{ $t('pages.Profile.Email') }} </b>{{email}}</label>
        </div>
        <a v-on:click="forgotPasswordButton" class="forgotButton">{{ $t('pages.Profile.SendEmail') }}</a>
        <a v-on:click="logout" style="color: #2B2B2B; text-decoration: underline;">Logout</a>
      </div>
  </div>
</template>

<script>
  import {forgotPassword} from "../api/Auth/apiAuth";
  import ClickOutside from 'vue-click-outside'
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default {
    name: "navbar-top",
    data() {
      return {
        show: false,
        routeName: '',
        toggle_profile: false,
        email: ''
      };
    },
    methods: {
      profile: function() {
        if(this.$router.currentRoute.path == '/profile') this.$router.push('/dashboard');
        else this.$router.push('/profile');
      },
      toggleProfile: function() {
        this.toggle_profile = !this.toggle_profile;
      },
      hideProfile: function() {
        this.toggle_profile = false;
      },
      redirectToHome: function() {
        this.$router.push('/');
      },
      forgotPasswordButton: function () {
        forgotPassword({email: localStorage.getItem('email')}).then(response => {
          if(this.$i18n.locale()=='pt') this.$toast.open(pt.pages.Profile.messageSent);
          if(this.$i18n.locale()=='en') this.$toast.open(en.pages.Profile.messageSent);
        }).catch((error) => {console.log(error); this.$toast.open({message: 'Algo correu mal', type: 'is-danger'})});
      },
      logout: function() {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem('color');
        localStorage.removeItem('image');
        localStorage.removeItem('organization');
        localStorage.removeItem('members');
        localStorage.setItem('language', 'pt');
        this.$router.push("/");
      }
    },
    mounted() {
      this.email = localStorage.getItem('email');
      if(this.$i18n.locale() == 'en'){
        if(this.$router.currentRoute.path=='/init_menu') this.routeName = 'Menu';
        if(this.$router.currentRoute.path=='/dashboard') this.routeName = 'Dashboard';
        if(this.$router.currentRoute.path=='/createSocio') this.routeName = 'Register';
        if(this.$router.currentRoute.path=='/createSocio2') this.routeName = 'Register';
        if(this.$router.currentRoute.path=='/createSocio3') this.routeName = 'Register';
        if(this.$router.currentRoute.path=='/listSocios') this.routeName = 'List Members';
        if(this.$router.currentRoute.path=='/listPayments') this.routeName = 'Payments';
        if(this.$router.currentRoute.path=='/csv') this.routeName = 'Download';
        if(this.$router.currentRoute.path=='/payment') this.routeName = 'Payment';
        if(this.$router.currentRoute.path=='/suporte') this.routeName = 'Support';
        if(this.$router.currentRoute.path=='/profile') this.routeName = 'Profile';
      }else if(this.$i18n.locale() == 'pt') {
        if(this.$router.currentRoute.path=='/init_menu') this.routeName = 'Menu';
        if(this.$router.currentRoute.path=='/dashboard') this.routeName = 'Dashboard';
        if(this.$router.currentRoute.path=='/createSocio') this.routeName = 'Registar';
        if(this.$router.currentRoute.path=='/createSocio2') this.routeName = 'Registar';
        if(this.$router.currentRoute.path=='/createSocio3') this.routeName = 'Registar';
        if(this.$router.currentRoute.path=='/listSocios') this.routeName = 'Lista Sócios';
        if(this.$router.currentRoute.path=='/listPayments') this.routeName = 'Pagamentos';
        if(this.$router.currentRoute.path=='/csv') this.routeName = 'Download';
        if(this.$router.currentRoute.path=='/payment') this.routeName = 'Pagamento';
        if(this.$router.currentRoute.path=='/suporte') this.routeName = 'Suporte';
        if(this.$router.currentRoute.path=='/profile') this.routeName = 'Perfil';
      }
    },
    directives: {
      ClickOutside
    }
  };
</script>

<style scoped>
  #navbarTop {
    background-color: #ECECEC;
    background-image: linear-gradient(to top, #ffffff, #ECECEC 75%);
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
    display: block;
    z-index: 1000;
    position: fixed;
    top: 0;
  }
  #navbarTop_desktop {
     background-color: #ECECEC;
     padding: 0px;
     width: 100%;
     height: 50px;
     z-index: 1000;
     position: fixed;
     top: 0;
     display: flex;
     justify-content: center;
     align-items: center;
  }
  .circletag {
    margin-left: 25%;
    padding: 0;
    display: block;
    width: 40%;
    border-radius: 1px;
    -moz-border-radius: 1px;
    -webkit-border-radius: 20px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }
  .logo_desktop {
    height: 60%;
    position: absolute;
    left: 20px;
    top: 20%;
  }
  .label_logo {
    color: white;
    position: absolute;
    left: 60px;
    top: 25%;
  }
  .avatar_desktop {
    height: 60%;
    position: absolute;
    right: 2%;
    top: 20%;
  }
  @media(max-width: 1200px) {
      .profile {
          position: absolute;
          z-index: 999;
          margin-top: 52px;
          top: 0;
          right: 0;
          width: 300px;
          height: 350px;
          background-color: white;
          border-bottom: 4px solid #ECECEC;
          border-left: 3px solid #ECECEC;
          border-bottom-left-radius: 22px;
      }
      .circle {
          width: 100px;
          margin: 20px auto 20px auto;
          border-radius: 100%;  
          -webkit-border-radius: 100%;
      }
  }
  @media(min-width: 1200px) {
      .profile {
          position: absolute;
          z-index: 999;
          margin-top: 52px;
          top: 0;
          right: 0;
          width: 300px;
          height: 350px;
          background-color: white;
          border-bottom: 4px solid #ECECEC;
          border-left: 3px solid #ECECEC;
          border-bottom-left-radius: 22px;
      }
      .circle {
          width: 100px;
          margin: 20px auto 20px auto;
          border-radius: 100%;  
          -webkit-border-radius: 100%;
      }
  }
  .forgotButton {
    background-color: #2B2B2B;
    border-color: #2B2B2B;
    color: white;
    width: 280px;
    display:inline-block;
    padding: 5px;
    border-radius: 32px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .forgotButton:hover {
    color: white;
  }
</style>
